import React, {Component} from 'react';

import {
    Button
} from 'reactstrap';

class CircleButton extends Component {
    render() {
        const {disabled, onClick, color, nomargin, outline, style, type} = this.props;

        return (
            <Button className={"btn-circle " + this.props.className}
                    disabled={disabled}
                    color={color || 'default'}
                    outline={outline}
                    style={style || {margin: nomargin ? '0' : '20px 20px'}}
                    onClick={onClick}
                    type={type || 'button'}
            >
                {this.props.children}
            </Button>
        );
    }
}

export default CircleButton;


// WEBPACK FOOTER //
// ./src/components/controls/buttons/CircleButton.js